import { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost";
  loading?: boolean;
}

export function Button({
  variant = "primary",
  loading,
  children,
  disabled,
  className = "",
  ...rest
}: ButtonProps) {
  // Swiss-минимализм (единство с лендингом): острые углы, uppercase, кобальт /
  // ghost-контур, hover → чёрный.
  const base =
    "inline-flex items-center justify-center gap-2 px-6 py-3.5 text-xs font-semibold uppercase tracking-[0.06em] border transition-all disabled:opacity-50 disabled:cursor-not-allowed";
  const styles = {
    primary:
      "bg-[var(--color-cobalt)] text-white border-[var(--color-cobalt)] hover:bg-[var(--color-ink)] hover:border-[var(--color-ink)]",
    secondary:
      "bg-[var(--color-cobalt)] text-white border-[var(--color-cobalt)] hover:bg-[var(--color-ink)] hover:border-[var(--color-ink)]",
    ghost:
      "bg-transparent text-[var(--color-ink)] border-[var(--color-ink)] hover:bg-[var(--color-ink)] hover:text-white",
  };
  return (
    <button
      {...rest}
      disabled={disabled || loading}
      className={`${base} ${styles[variant]} ${className}`}
    >
      {loading ? "..." : children}
    </button>
  );
}
